var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51042 11.0677C3.99349 11.0677 1.95312 9.02734 1.95312 6.51042C1.95312 3.99349 3.99349 1.95312 6.51042 1.95312C9.02734 1.95312 11.0677 3.99349 11.0677 6.51042C11.0677 9.02734 9.02734 11.0677 6.51042 11.0677Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76563 9.76563L13.6719 13.6719M6.51042 11.0677C3.99349 11.0677 1.95312 9.02734 1.95312 6.51042C1.95312 3.99349 3.99349 1.95312 6.51042 1.95312C9.02734 1.95312 11.0677 3.99349 11.0677 6.51042C11.0677 9.02734 9.02734 11.0677 6.51042 11.0677Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.308206764433788d3c0afa8e05442859.svg";
export { ForwardRef as ReactComponent };